let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kzCMD")).then(() => parcelRequire('kmi1F'));